<template>
	<div class="LocalBusPage">

		<v-card style="height:90vh" flat tile class="d-flex align-content-space-around flex-wrap "  v-if="isLocalBusLoading"
			transition="fade-transition">
			<v-col>
				<v-row justify="center" align="center">
					<svg version="1.1" id="Livello_1" x="0px" y="0px" viewBox="0 0 614 435.2"
						style="width:150px;enable-background:new 0 0 614 435.2;" xml:space="preserve">

						<g>
							<path class="st0" d="M9.7,362.6h14.5v59.3H9.7V362.6z" />
							<path class="st0" d="M49.6,375h-18v-12.4h50.5V375h-18v46.9H49.6V375z" />
							<path class="st0" d="M116,409.4H97.5l-3.6,12.4H79l20.2-59.3h15.3l20.2,59.3h-14.9L116,409.4z M106.7,376.1c0,0-1.3,6.5-2.4,10.2
		l-3.4,11.5h11.7l-3.3-11.5c-1.1-3.7-2.4-10.2-2.4-10.2H106.7z" />
							<path class="st0" d="M141.2,362.6h14.5v46.9H180v12.4h-38.7V362.6z" />
							<path class="st0" d="M196.1,397.6l-19.6-35H193l6.7,14.3c1.9,4.1,3.6,8.5,3.6,8.5h0.2c0,0,1.7-4.5,3.6-8.5l6.6-14.3h16.5l-19.6,35
		v24.3h-14.5V397.6z" />
							<path class="st0" d="M238,408.9c0,0,6.2,6.3,14.9,6.3c5.5,0,10.1-3.1,10.1-8.6c0-12.7-28.4-10-28.4-28c0-9.1,7.9-16.3,18.9-16.3
		c10.9,0,16.6,5.9,16.6,5.9l-3.7,6.8c0,0-5.4-5.1-12.9-5.1c-6.2,0-10.6,3.9-10.6,8.5c0,12.1,28.4,8.9,28.4,27.9
		c0,9-7,16.5-18.6,16.5c-12.4,0-19.4-7.7-19.4-7.7L238,408.9z" />
							<path class="st0"
								d="M283.2,363.3h34v7.1h-25.8v18.3h21v7.1h-21v18.8h27.2v7.1h-35.4V363.3z" />
							<path class="st0" d="M330.7,363.3h17.9c6.1,0,8.7,0.5,11,1.3c6,2.2,9.9,8.1,9.9,15.8c0,7.5-4.1,13.8-10.5,15.8v0.2
		c0,0,0.7,0.7,1.7,2.7l12.4,22.7h-9.3l-12.4-23.3h-12.5v23.3h-8.2V363.3z M350.7,391.4c6.4,0,10.4-4.1,10.4-10.6
		c0-4.3-1.7-7.4-4.6-9c-1.6-0.8-3.5-1.3-8-1.3h-9.5v21H350.7z" />
							<path class="st0" d="M376.5,363.3h8.9l14.5,41.4c1.1,3.2,2.2,8,2.2,8h0.2c0,0,1.2-4.9,2.2-8l14.7-41.4h8.7l-21.6,58.6h-8.2
		L376.5,363.3z" />
							<path class="st0" d="M436.4,363.3h8.2v58.6h-8.2V363.3z" />
							<path class="st0" d="M486.3,362.3c14.1,0,21.3,7.7,21.3,7.7l-4.1,6.1c0,0-6.8-6.4-16.9-6.4c-13.1,0-21.7,10-21.7,22.4
		c0,12.5,8.7,23.1,21.7,23.1c11,0,18.1-7.6,18.1-7.6l4.4,5.9c0,0-8,9.3-22.7,9.3c-17.6,0-29.9-13.4-29.9-30.6
		C456.5,375.3,469.3,362.3,486.3,362.3z" />
							<path class="st0"
								d="M520.5,363.3h34v7.1h-25.8v18.3h21v7.1h-21v18.8h27.2v7.1h-35.4V363.3z" />
							<path class="st0" d="M568.2,408.9c0,0,6.2,6.3,14.9,6.3c5.5,0,10.1-3.1,10.1-8.6c0-12.7-28.4-10-28.4-28c0-9.1,7.9-16.3,18.9-16.3
		c10.9,0,16.6,5.9,16.6,5.9l-3.7,6.8c0,0-5.4-5.1-12.9-5.1c-6.2,0-10.6,3.9-10.6,8.5c0,12.1,28.4,8.9,28.4,27.9
		c0,9-7,16.5-18.6,16.5c-12.4,0-19.4-7.7-19.4-7.7L568.2,408.9z" />
						</g>
						<g>
							<path class="st1" d="M235.7,214.2c2.6,1.3,4.7,2.8,6.2,4.9c18.6-7.8,35.9-16.5,51.9-25.6c-1-3.6-0.8-7.5,1-11.4
		c0-0.3,0.3-0.3,0.3-0.5c-17.8-15.2-40.1-29.7-67.2-42.1c-1.3,1.6-2.8,2.8-4.7,3.9c4.7,20.9,8.3,44.2,9.6,69.5
		C233.7,213.5,234.7,214,235.7,214.2z" />
							<path class="st1" d="M214.8,239.3c-14.7,4.9-30.5,9.3-46.8,12.9c12.7,20.7,29.7,38.2,50.1,51.4c3.4-20.2,5.2-39.5,5.7-57.9
		c-0.8-0.3-1.3-0.5-2.1-0.8C218.7,244,216.4,241.9,214.8,239.3z" />
							<path class="st1" d="M381.7,152.5c-3.1,0.5-6.5,0-9.6-1.3c-0.8-0.3-1.3-0.8-2.1-1c-12.9,11.4-27.4,23-43.9,34.1
		c1.3,3.9,1,8.3-0.8,12.1c-0.3,0.5-0.5,1-0.8,1.6c7,7.5,13.4,15.8,19.6,24.3c7.5,10.6,13.7,21.2,18.9,31.3c2.1-1.8,4.4-3.1,7-3.6
		C370.9,227.7,376.6,180.1,381.7,152.5z" />
							<path class="st1" d="M277.6,299.5c0.3-0.5,0.5-1,0.8-1.6c-7-7.5-13.4-15.8-19.6-24.3c-7.5-10.6-13.7-21.2-18.9-31.3
		c-2.1,1.8-4.4,3.1-7,3.6c-0.5,19.9-2.6,40.8-6.5,62.8c10.6,5.9,22.2,10.9,34.1,14.5c5.2-3.9,10.6-7.8,16.3-11.6
		C275.8,307.8,275.8,303.4,277.6,299.5z" />
							<path class="st1" d="M336.8,227.2c-5.2-7.5-11.4-15-18.6-22.7c-4.4,2.3-10.1,2.8-15,0.5c-1.8-0.8-3.4-1.8-4.7-3.1
		c-16.3,9-33.9,18.1-53,26.1c0.3,1.6,0.3,3.4-0.3,4.9c5.4,11.6,12.4,23.8,21.2,35.9c5.2,7.5,11.4,15,18.6,22.7
		c4.4-2.3,10.1-2.8,15-0.5c1.8,0.8,3.4,1.8,4.7,3.1c16.3-9.3,33.9-18.3,53-26.4c-0.3-1.6-0.3-3.4,0.3-4.9
		C352.3,251.5,345.3,239.3,336.8,227.2z" />
							<path class="st1"
								d="M214.8,112.2c2.3,0,4.9,0.5,7.2,1.6c7,3.1,10.9,10.6,9.8,17.8c24.5,11.1,48.1,25.3,69.5,43.7
		c4.7-2.8,10.6-3.4,16-1c1.6,0.8,2.8,1.6,3.9,2.6c16-10.9,30.2-22,42.9-33.1c-1.6-3.4-2.1-7.2-1.3-11.1c-2.8-1.6-5.7-3.4-8.3-5.2
		C321,106.2,281.7,71.1,256.4,15c-24.5,8-46.5,21.4-64.3,39.3c5.9,11.9,11.6,25.3,17.1,40.3C210.7,100,212.7,106,214.8,112.2z" />
							<path class="st1" d="M201.1,119.4c1.3-1.8,2.8-3.4,4.9-4.7c-1.8-5.9-3.9-11.9-5.9-17.3c-4.7-13.2-9.8-25.3-15.2-36.2
		c-11.9,13.4-21.7,28.9-28.4,45.7C171.1,110.1,186.1,114.2,201.1,119.4z" />
							<path class="st1" d="M359.3,119.4c2.6,1.6,5.2,3.1,7.8,4.7c4.9-4.9,12.4-6.7,19.1-3.6c0.5,0.3,0.8,0.5,1.3,0.8
		c18.1-18.3,32.8-36.7,44.7-53C402.7,31,356.9,7,305.8,7c-14.2,0-27.9,1.8-40.8,5.2C289.5,65.7,327.2,99,359.3,119.4z" />
							<path class="st1" d="M301.9,321c-4.7,2.8-10.6,3.4-16,1c-1.6-0.8-2.8-1.6-3.9-2.6c-3.4,2.3-6.7,4.7-9.8,7c10.9,2.3,22,3.6,33.6,3.6
		c2.3,0,4.7,0,7-0.3C309.1,326.9,305.5,323.8,301.9,321z" />
							<path class="st1" d="M211.7,230.5c-0.3-2.6,0.3-5.2,1.6-7.8c2.1-4.4,5.7-7.8,10.1-9c-1.3-24.8-4.7-47.3-9.3-67.7
		c-2.1,0-4.1-0.5-6.2-1.6c-6.7-3.1-10.3-9.8-9.8-16.5c-13.7-4.7-28.7-9-45-12.4c-5.7,16.5-8.8,34.4-8.8,52.7
		c0,27.4,6.7,53,18.9,75.7C180.2,240.3,196.5,235.7,211.7,230.5z" />
							<path class="st1" d="M393.9,127.7c1.8,3.4,2.6,7.2,1.8,11.1c6.2,2.8,45,16.8,71.3,26.1c-0.8-33.1-11.4-63.8-29.2-89.2
		C426.2,92,411.7,109.6,393.9,127.7z" />
							<path class="st1" d="M367.5,281.4c-2.6-1.3-4.7-2.8-6.2-4.9c-18.6,7.8-35.9,16.5-51.9,25.6c1,3.6,0.8,7.5-1,11.4
		c0,0.3-0.3,0.3-0.3,0.5c5.7,4.9,11.9,9.8,18.6,14.5c16.5-2.1,32-6.7,46.8-13.4c-1.3-10.3-2.3-21.2-2.8-32.3
		C369.6,282.2,368.6,281.9,367.5,281.4z" />
							<path class="st1" d="M444.5,250.9c-18.6,3.9-36.4,8.5-53,14.2c0.3,2.6-0.3,5.2-1.6,7.8c-2.1,4.4-5.7,7.8-10.1,9
		c0.5,9.8,1.3,19.4,2.3,28.4C408.1,296.7,429.5,276,444.5,250.9z" />
							<path class="st1" d="M391.8,147.1c-4.9,26.4-11.9,80.9-12.4,102.8c0.8,0.3,1.3,0.5,2.1,0.8c2.8,1.3,5.2,3.4,7,5.9
		c19.4-6.5,39.8-11.9,61.8-16c10.1-19.9,16-42.1,16.8-65.6C440.7,165.4,398.8,150.2,391.8,147.1z" />
						</g>
					</svg>
				</v-row>
				<v-row justify="center" align="center">
					<v-progress-circular tile :size="70" :width="2" color="blue" indeterminate></v-progress-circular>
				</v-row>
			</v-col>
		</v-card>
		
		<v-list v-if="!isLocalBusLoading" transition="fade-transition">
			<v-subheader>{{ $t('nearest_stops') }}</v-subheader>
			<v-list-item-group color="primary">
				<v-list-item v-for="(stop, i) in localBusList" :key="i">
					<v-list-item-icon>
						<svg height='3rem' width='3rem'  fill="#000000" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"><path d="M66.667,8.333C55.803,8.333,46.54,15.301,43.1,25H16.667c-4.602,0-8.333,5.814-8.333,8.333V75  c0,4.602,3.731,8.333,8.333,8.333v8.333h8.784v-8.333H50v8.333h8.784v-8.379c4.388-0.239,7.883-3.84,7.883-8.288V58.333c0,0,0,0,0,0  c13.785,0,25-11.215,25-25C91.667,19.548,80.452,8.333,66.667,8.333z M20.833,75c-2.301,0-4.167-1.866-4.167-4.167  c0-2.301,1.865-4.167,4.167-4.167c2.301,0,4.167,1.865,4.167,4.167C25,73.134,23.135,75,20.833,75z M54.167,75  C51.865,75,50,73.134,50,70.833c0-2.301,1.865-4.167,4.167-4.167s4.167,1.865,4.167,4.167C58.333,73.134,56.468,75,54.167,75z   M58.333,58.333H16.667V37.5H42.02c1.52,9.018,7.882,16.409,16.313,19.399V58.333z M66.667,50C57.477,50,50,42.523,50,33.333  s7.477-16.667,16.667-16.667c9.189,0,16.666,7.477,16.666,16.667S75.856,50,66.667,50z"></path><polygon points="70.834,20.833 62.5,20.833 62.5,37.5 79.167,37.5 79.167,29.167 70.834,29.167 "></polygon></svg>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title v-text="stop.name"></v-list-item-title>
					</v-list-item-content>
					<v-list-item-action>
						<v-list-item-action-text v-text="stop.distance.toFixed(0).toString()+' m'"></v-list-item-action-text>
					</v-list-item-action>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</div>
</template>

<script>
/* eslint-disable no-console */
import {mapState} from 'vuex';

  //import axios from 'axios';
  export default {

	name: 'LocalBusPage',
	data() {
		return {
			isLocalBusLoading: false
		}
	},
	computed: {
		...mapState(['localBusList']),
	},
   async mounted() {
		console.log("Local Bus Mounted")
this.isLocalBusLoading= true
		try {
			
			await this.$store.dispatch('localBusList')
			this.isLocalBusLoading=false
		} catch (error) {
			console.log("error",error)
			this.isLocalBusLoading=false
		}
    },
    created() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.st0{fill:#231F20;}
	.st1{fill:#30AADF;}

</style>
